import scroll from 'core/scroll'
import detect from 'helpers/detect'

import PageManager from './PageManager'

class SuperPageManager extends PageManager {
  removePage () {
    super.removePage()
    scroll.reset()
  }

  extractPageFromXHR (el) {
    if (detect.safari) {
      if (!this.tmpDiv) this.tmpDiv = document.createElement('div')
      this.tmpDiv.innerHTML = '' + el.innerHTML
      return super.extractPageFromXHR(this.tmpDiv)
    }
    return super.extractPageFromXHR(...arguments)
  }
}

export default SuperPageManager
